import { FiHome, FiMenu, FiX } from 'react-icons/fi';
import { NavLink, useLocation } from 'react-router-dom';
import { useSidebar } from './SidebarContext';

const navItems = [{ path: '/', label: 'Dashboard', icon: FiHome }];

export function Sidebar() {
	const { isOpen, close } = useSidebar();
	const location = useLocation();

	return (
		<>
			<div
				className={`fixed inset-0 z-40 bg-black/50 lg:hidden transition-opacity ${isOpen ? 'opacity-100' : 'opacity-0 pointer-events-none'}`}
				onClick={close}
				aria-hidden="true"
			/>
			<aside
				id="sidebar"
				className={`fixed top-0 left-0 z-50 h-full w-64 bg-white border-r border-gray-200 transform transition-transform duration-200 lg:translate-x-0 ${isOpen ? 'translate-x-0' : '-translate-x-full'}`}
				role="navigation"
				aria-label="Menu principal"
			>
				<div className="flex h-16 items-center justify-between px-4 border-b border-gray-200">
					<h1 className="text-lg font-semibold text-gray-900">Achei Comunidade</h1>
					<button
						className="lg:hidden p-2 rounded-md text-gray-500 hover:text-gray-700 hover:bg-gray-100"
						onClick={close}
						aria-label="Fechar menu"
					>
						<FiX size={24} />
					</button>
				</div>

				<nav className="p-4 space-y-1" aria-label="Navegação principal">
					{navItems.map((item) => (
						<NavLink
							key={item.path}
							to={item.path}
							onClick={close}
							className={({ isActive }) =>
								`flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors ${
									isActive
										? 'bg-primary-50 text-primary-700'
										: 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
								}`
							}
						>
							<item.icon size={20} aria-hidden="true" />
							{item.label}
						</NavLink>
					))}
				</nav>
			</aside>
		</>
	);
}

export function Header() {
	const { isOpen, toggle } = useSidebar();
	const location = useLocation();

	return (
		<header className="sticky top-0 z-30 h-16 bg-white border-b border-gray-200 lg:ml-64">
			<div className="flex h-full items-center justify-between px-4">
				<div className="flex items-center gap-4">
					<button
						className="lg:hidden p-2 rounded-md text-gray-500 hover:text-gray-700 hover:bg-gray-100"
						onClick={toggle}
						aria-label={isOpen ? 'Fechar menu' : 'Abrir menu'}
						aria-expanded={isOpen}
						aria-controls="sidebar"
					>
						<FiMenu size={24} />
					</button>

					<h2 className="text-lg font-semibold text-gray-900 hidden sm:block">
						{location.pathname === '/' ? 'Dashboard' : 'Itens Encontrados'}
					</h2>
				</div>
			</div>
		</header>
	);
}
